/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import backofficeEnviroment from "utils/backofficeEnviroment";

interface Props {
  codigoEtapa: string | undefined;
  comercial: boolean;
}

export function usePropostasFiltrosSubEtapas(props: Props) {
  const LISTAR_SUBETAPA = `${backofficeEnviroment}/common/backoffice/sub-etapas/v1?CodigoEtapa=${props.codigoEtapa}&Comercial=${props.comercial}`;
  const fetchData = async () => {
    const response = await instance.get(LISTAR_SUBETAPA);
    return response?.data?.data;
  };
  const query = useQuery({
    queryFn: fetchData,
    queryKey: ["propostas-filtro-subetapas"],
    refetchOnWindowFocus: false,
    enabled: false,
  });
  return query;
}
